import React, { useEffect, useState } from 'react';
import { useStock } from '../../context/StockContext';

const T = '#0F6E56';

export default function StockMovements() {
  const { movements, fetchAll } = useStock();
  const [typeFilter, setTypeFilter] = useState('');

  useEffect(() => { fetchAll(); }, []);

  const filtered = typeFilter ? movements.filter(m=>m.type===typeFilter) : movements;

  const typeStyle = { in:{bg:'#E1F5EE',color:T,label:'Entrée',icon:'📥'}, out:{bg:'#fee2e2',color:'#dc2626',label:'Sortie',icon:'📤'}, adjust:{bg:'#f3f0ff',color:'#7C3AED',label:'Ajustement',icon:'🔄'} };

  return (
    <div style={{ maxWidth:900, margin:'0 auto', padding:'1.5rem' }}>
      <h1 style={{ fontSize:20, fontWeight:600, marginBottom:'1.5rem' }}>Historique des mouvements</h1>

      <div style={{ display:'flex', gap:8, marginBottom:'1rem' }}>
        {[['','Tous'],['in','Entrées'],['out','Sorties'],['adjust','Ajustements']].map(([v,l])=>(
          <button key={v} onClick={()=>setTypeFilter(v)} style={{ background:typeFilter===v?'#0B3D6E':'#fff', color:typeFilter===v?'#fff':'#64748b', border:'1px solid #e2e8f0', padding:'6px 14px', borderRadius:8, fontSize:12, fontWeight:typeFilter===v?600:400, cursor:'pointer' }}>{l}</button>
        ))}
      </div>

      <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
        <div style={{ overflowX:'auto' }}>
          <table style={{ width:'100%', borderCollapse:'collapse', minWidth:500 }}>
            <thead>
              <tr style={{ background:'#f8fafc' }}>
                {['Date','Produit','Type','Qté avant','Mouvement','Qté après','Motif'].map(h=>(
                  <th key={h} style={{ textAlign:'left', fontSize:11, fontWeight:600, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.5px', padding:'10px 14px', whiteSpace:'nowrap' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(m => {
                const ts = typeStyle[m.type]||typeStyle.adjust;
                return (
                  <tr key={m._id} style={{ borderTop:'1px solid #f1f5f9' }}>
                    <td style={{ padding:'10px 14px', fontSize:12, color:'#94a3b8', whiteSpace:'nowrap' }}>{new Date(m.createdAt).toLocaleDateString('fr-FR')}<br/><span style={{ fontSize:10 }}>{new Date(m.createdAt).toLocaleTimeString('fr-FR',{hour:'2-digit',minute:'2-digit'})}</span></td>
                    <td style={{ padding:'10px 14px', fontSize:13, fontWeight:500 }}>{m.productName||m.product?.name||'—'}</td>
                    <td style={{ padding:'10px 14px' }}><span style={{ background:ts.bg, color:ts.color, fontSize:11, fontWeight:600, padding:'3px 8px', borderRadius:8 }}>{ts.icon} {ts.label}</span></td>
                    <td style={{ padding:'10px 14px', fontSize:13, color:'#64748b' }}>{m.quantityBefore??'—'}</td>
                    <td style={{ padding:'10px 14px', fontSize:13, fontWeight:700, color:ts.color }}>{m.type==='in'?'+':m.type==='out'?'-':''}{m.quantity}</td>
                    <td style={{ padding:'10px 14px', fontSize:13, fontWeight:600 }}>{m.quantityAfter??'—'}</td>
                    <td style={{ padding:'10px 14px', fontSize:12, color:'#64748b' }}>{m.reason||'—'}{m.note&&<div style={{ fontSize:10, color:'#94a3b8' }}>{m.note}</div>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {filtered.length===0 && <div style={{ textAlign:'center', padding:'2.5rem', color:'#94a3b8' }}>Aucun mouvement enregistré</div>}
        </div>
      </div>
    </div>
  );
}

